import { useEffect, useMemo, useState } from 'react';
import {
  isMobileScreen, isDesktopScreen, isTabletScreen, isXlScreen,
} from 'utils/screenHelper';

export const useDimension = () => {
  const isClient = typeof window === 'object';
  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
    };
  }
  const [windowSize, setWindowSize] = useState(getSize);
  useEffect(() => {
    if (!isClient) {
      return false;
    }
    function handleResize() {
      setWindowSize(getSize());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return windowSize;
};

export const useScreen = () => {
  const { width, height } = useDimension();

  const screen = useMemo(() => ({
    isMobileScreen: isMobileScreen(),
    isTabletScreen: isTabletScreen(),
    isDesktopScreen: isDesktopScreen(),
    isXlScreen: isXlScreen(),
  }
    // eslint-disable-next-line
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ), [width, height]);

  return screen;
};
